"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeAuthStatus = exports.getCurrentAuthStatus = exports.redirectToLogout = exports.redirectToAuthority = exports.redirectToLogin = void 0;
const client_1 = require("../../build-babel/auth/client");
const msal_browser_1 = require("@azure/msal-browser");
const redirect_1 = require("../../build-babel/redirect");
const storage_1 = require("../../build-babel/token/storage");
const index_1 = require("../../build-babel");
const loginAttempts_1 = require("../../build-babel/utils/loginAttempts");
const session_1 = require("../../build-babel/session");
const cookieBanner_1 = require("../../build-babel/cookieBanner");
const getExtraQueryParams = () => (0, cookieBanner_1.getCookieConsentBannerExtraQueryParam)();
const loginRequest = {
  scopes: []
};
const loginRedirectRequest = Object.assign(Object.assign({}, loginRequest), {
  extraQueryParameters: getExtraQueryParams()
});
// for login
const redirectToLogin = () => __awaiter(void 0, void 0, void 0, function* () {
  (0, loginAttempts_1.registerLoginAttempt)();
  if ((0, loginAttempts_1.isLoginAttemptsLimitExceeded)()) {
    (0, loginAttempts_1.removeLoginAttempts)();
    yield (0, index_1.signOut)();
    return;
  }
  // check client and server sessions both
  const baseUrl = window.location.href;
  const serverSideSession = yield (0, exports.getCurrentAuthStatus)();
  if (!serverSideSession) {
    (0, session_1.removeSession)(baseUrl, false);
    yield (0, client_1.get)((msalClient, msalRedirectResponse) => __awaiter(void 0, void 0, void 0, function* () {
      if (!msalRedirectResponse) {
        yield msalClient.loginRedirect(Object.assign({}, loginRedirectRequest));
      }
    }));
  } else {
    // there's server side session
    // behaviour depends on client side session
    if ((0, session_1.hasValidSession)(baseUrl)) {
      // user has both valid sessions - redirect next
      const token = (0, storage_1.getToken)();
      token ? (0, redirect_1.redirectNext)(token) : (0, redirect_1.redirectNext)();
    } else {
      // client side session is not valid
      yield (0, index_1.signOut)();
    }
  }
});
exports.redirectToLogin = redirectToLogin;
// for personal information and account settings
const redirectToAuthority = authority => __awaiter(void 0, void 0, void 0, function* () {
  yield (0, client_1.get)(msalClient => __awaiter(void 0, void 0, void 0, function* () {
    yield msalClient.acquireTokenRedirect(Object.assign(Object.assign({}, loginRedirectRequest), {
      authority
    }));
  }));
});
exports.redirectToAuthority = redirectToAuthority;
// for logout
const redirectToLogout = postLogoutRedirectUri => __awaiter(void 0, void 0, void 0, function* () {
  yield (0, client_1.get)(msalClient => __awaiter(void 0, void 0, void 0, function* () {
    const account = msalClient.getActiveAccount();
    yield msalClient.logoutRedirect({
      account,
      postLogoutRedirectUri,
      extraQueryParameters: getExtraQueryParams()
    });
  }));
});
exports.redirectToLogout = redirectToLogout;
// auth status
const getCurrentAuthStatus = () => __awaiter(void 0, void 0, void 0, function* () {
  let authStatus = false;
  const msalClient = yield (0, client_1.getMsalClient)();
  try {
    const activeAccount = msalClient.getActiveAccount();
    if (activeAccount) {
      const authResponse = yield msalClient.acquireTokenSilent(loginRequest);
      authStatus = !!authResponse.idToken;
    }
  } catch (e) {
    // skip the error
    console.log(e);
  }
  return Promise.resolve(authStatus);
});
exports.getCurrentAuthStatus = getCurrentAuthStatus;
const observeAuthStatus = onLoginStatusChange => __awaiter(void 0, void 0, void 0, function* () {
  const LOGIN_EVENTS = [msal_browser_1.EventType.LOGIN_SUCCESS, msal_browser_1.EventType.ACCOUNT_ADDED];
  const LOGOUT_EVENTS = [msal_browser_1.EventType.LOGOUT_SUCCESS, msal_browser_1.EventType.ACCOUNT_REMOVED];
  const msalClient = yield (0, client_1.get)();
  msalClient.addEventCallback(message => {
    if (LOGIN_EVENTS.includes(message.eventType)) {
      onLoginStatusChange(true);
    }
    if (LOGOUT_EVENTS.includes(message.eventType)) {
      onLoginStatusChange(false);
    }
  });
});
exports.observeAuthStatus = observeAuthStatus;
//# sourceMappingURL=index.js.map